export * from './IconCommentStroked';
